module.exports = "https://static.im-cdn.com/mjc/storefront/Essense/static/media/LChevron1.3aba3059.svg";